// client/src/config/fiscal.ts — whether the fiscal module is on screen · D-2780.
//
// On 2026-09-29 the Product Owner withdrew the fiscal module from view: the „Fiscal" sidebar
// group („Obligații fiscale", „Calendar fiscal", „Profil fiscal") and every fiscal surface the
// other screens carry — the dashboard's obligations card, the apartment's „Situație fiscală",
// the C168 chips, tab and package on a contract, the co-owners' C168 declarant, the fiscal
// deadlines of the compliance calendar, the fiscal report family and the „Dosar fiscal anual",
// the estimated income tax and CASS in „Bilanț", an expense's fiscal treatment, the fiscal
// component of the health score, the fiscal notification families and the fiscal documents.
//
// HIDDEN, NOT DELETED. Every component, query, route and row is kept, and the screens ask this
// one function whether to draw them — the seam `utility-payments.ts` (D-2700) gave the utility
// payments. The server holds the other half: `WithdrawnFromView` keeps the fiscal task kinds and
// notification families out of the Action Center and the inbox, so the counts above those lists
// agree with them. Turning the module back on is this function answering `true` and that
// class's two lists emptied, in one change.
//
// A FUNCTION rather than a constant, for `app-meta.ts`'s reason: a test can then say „given the
// fiscal module is on" and keep exercising the screens that are only hidden (`vi.mock` of this
// module), and a `false` literal would read to the linter as a condition that never holds.

/** `false` while the fiscal module is withdrawn from view (D-2780). */
export function fiscalVisible(): boolean {
  return false;
}
